<div class="container">
  <app-breadcrumb [items]="breadcrumbs()" [showLastRoute]="false" />

  <h1>{{ title() }}</h1>
  <p class="subtitle">{{ subtitle() }}</p>

  <div class="tab-container">
    <div class="tabs">
      <button
        [class.active]="activeTab() === 'schema'"
        (click)="activeTab.set('schema')"
      >
        Schema
      </button>
      <button
        [class.active]="activeTab() === 'dashboard'"
        (click)="activeTab.set('dashboard')"
      >
        Dashboard
      </button>
    </div>
    @if (dataSet() !== null && dataSet()?.timestamp !== null) {
      <div class="last-sync">
        <img src="images/icon_clock.png" alt="clock" />
        <span>Last sync: {{ dataSet()?.timestamp }}</span>
      </div>
    }
  </div>

  @if (activeTab() === 'schema') {
    <app-data-set-schema [dataSetFeatures]="dataSet()?.features ?? []" />
  } @else if (activeTab() === 'dashboard') {
    <app-data-set-dashboard [dataSetFeatures]="dataSet()?.features ?? []" />
  }
</div>
